import type { NamespaceTester } from "src/lib/i18next/types.ts";
import { getAllModulesIds } from "src/system/getAllModulesIds.ts";
import { camelToKebabCase } from "@exonn/utils";

export const resourceFormTab: NamespaceTester = (ns: string, lang: string) => {
  const match = ns.match(/^module-(.+)-([^-]+)-([^-]+)$/);

  if (match) {
    const resource = match[1];
    const tab = match[3];
    const tabFolderName = camelToKebabCase(tab);

    const modules = getAllModulesIds();
    const forms = import.meta.glob(
      "../../../admin/modules/*/forms/**/locales/*.json",
    );
    for (let i = 0; i < modules.length; i++) {
      const moduleId = modules[i];
      const relatePath = `../../../admin/modules/${moduleId}/forms/${resource}/locales/${lang}.json`;

      if (forms[relatePath]) {
        return `src/admin/modules/${moduleId}/forms/${resource}/tabs/${tabFolderName}/locales/${lang}.json`;
      }
    }
    throw new Error("cannot load form tab translations");
  }
};
